export const CheckLanguageImg = (id) => {
  switch (id) {
    case "th":
      return "th";
    case "en":
      return "gb";
    case "zh":
      return "cn";
    case "ms":
      return "my";
    case "hi":
      return "in";
    case "lo":
      return "la";
    case "id":
      return "id";
    case "vi":
      return "vn";
    case "fil":
      return "ph";
    case "ja":
      return "jp";
    case "ko":
      return "kr";
    default:
      return "en";
  }
};
//
